import { FC } from 'react'
import { MiFooter } from '../../components/mi/Footer'
import { MiNavbar } from '../../components/mi/Navbar'
import { ContractsSection } from '../../components/mi/contracts/list'
import { StyleBody } from '../../styles/mi'

export const Contracts: FC = () => {
  return (
    <StyleBody>
      <MiNavbar />
      <ContractsSection></ContractsSection>
      <MiFooter />
    </StyleBody>
  )
}
